var React = require('react');

function ContentPin (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M22.1,0C9.9,0,0,10,0,22.2c0,4.8,1.6,9.4,4.4,13.3l17.7,23.6l17.8-23.6c7.3-9.8,5.4-23.7-4.4-31\n\t\t\tC31.6,1.5,26.9,0,22.1,0z M22.1,29.5c-4.1,0-7.4-3.3-7.4-7.4s3.3-7.4,7.4-7.4s7.4,3.3,7.4,7.4c0,0,0,0,0,0l0,0\n\t\t\tC29.5,26.2,26.2,29.5,22.1,29.5z"}))));
}

ContentPin.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 44.3 59.1","style":{"enableBackground":"new 0 0 44.3 59.1"},"xmlSpace":"preserve"};

module.exports = ContentPin;

ContentPin.default = ContentPin;
